import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';
import langs from '../../libs/jsonParsers/langs';

const initialState = {
    currentLang: 'English',
    EXISTING_LANGS: [...langs],
}

const choose_lang = (state, action) => {
    return updateObject(state, {
        currentLang: action.lang,
    }); 
}

const reducer = (state = initialState, action) => {
    if(action.type === actionTypes.CHOOSE_LANG){
        return choose_lang(state, action);
    }
    return state;
};

export default reducer;